import { render, staticRenderFns } from "./ModalUpdateShipping.vue?vue&type=template&id=90762afc&scoped=true"
import script from "./ModalUpdateShipping.vue?vue&type=script&lang=js"
export * from "./ModalUpdateShipping.vue?vue&type=script&lang=js"
import style0 from "./ModalUpdateShipping.vue?vue&type=style&index=0&id=90762afc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90762afc",
  null
  
)

export default component.exports